/* eslint-disable */
const awsmobile = {
  aws_project_region: import.meta.env.VITE_APP_AWS_REGION,
  aws_appsync_graphqlEndpoint: import.meta.env.VITE_APP_FORMS_DATASTORE_APPSYNC_API_END_POINT,
  aws_appsync_region: import.meta.env.VITE_APP_AWS_REGION,
  aws_appsync_authenticationType: import.meta.env.VITE_APP_FORMS_DATASTORE_AUTH_TYPE,
  Auth: {
    region: import.meta.env.VITE_APP_AWS_REGION,
    userPoolId: import.meta.env.VITE_APP_USER_POOL_ID,
    userPoolWebClientId: import.meta.env.VITE_APP_USER_POOL_CLIENT_ID,
    ...(import.meta.env.VITE_APP_IDENTITY_POOL_ID ? { identityPoolId: import.meta.env.VITE_APP_IDENTITY_POOL_ID } : {}),
  },
};

export default awsmobile;
